import React from 'react';
import { Security } from '@vis-auth/react';
import getAuthConfig from '../../utils/getAuthConfig';
import { useEnvironment } from '../Environment/EnvironmentContext';

const SecurityProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { AUTH_CLIENTID, LOGIN_DOT_GOV_AUTH_CLIENTID, LOGIN_DOT_GOV_URL } = useEnvironment();
  const authConfig = getAuthConfig(AUTH_CLIENTID, LOGIN_DOT_GOV_AUTH_CLIENTID, LOGIN_DOT_GOV_URL);

  return <Security authConfig={authConfig}>{children}</Security>;
};

export default SecurityProvider;
